import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=3a533380&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=3a533380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a533380",
  null
  
)

export default component.exports